import React, { useRef } from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import './ScreenReader.scss'

const ScreenReaderCTA = ({ intl }) => {
  const url = intl.formatMessage({ id: 'global.accessibility.linkURL' })
  const urlTitle = intl.formatMessage({ id: 'global.accessibility.linkTitle' })

  const linkRef = useRef(null)

  return (
    <div
      className="sr-container"
      role="region"
      aria-label={intl.formatMessage({
        id: 'global.accessibility.regionLabel',
        defaultMessage: 'Accessibility options',
      })}
    >
      <a className="sr-link sr-only" href={url} aria-label={urlTitle} tabIndex={-1} ref={linkRef}>
        {urlTitle}
      </a>
    </div>
  )
}

ScreenReaderCTA.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(ScreenReaderCTA)
